import { Button } from "antd";

import styles from "./CommunicationTemplateForm.module.scss";

export interface CommunicationTemplateFormFooterProps {
    saveAsDraft: () => void;
    saveAsLive: () => void;
    isLoading: boolean;
    isUpdating: boolean;
    isDraft: boolean;
}

export default function CommunicationTemplateFormFooter({
    saveAsDraft,
    saveAsLive,
    isLoading,
    isUpdating,
    isDraft,
}: CommunicationTemplateFormFooterProps) {
    return (
        <footer className={styles.formFooter}>
            <Button
                data-testid="save-template-as-draft"
                loading={isUpdating && isDraft}
                disabled={isLoading || isUpdating}
                onClick={saveAsDraft}
            >
                Save as Draft
            </Button>

            <Button
                data-testid="save-template-as-live"
                type="primary"
                loading={isUpdating && !isDraft}
                disabled={isLoading || isUpdating}
                onClick={saveAsLive}
            >
                Save as Live
            </Button>
        </footer>
    );
}
